module.exports = __webpack_public_path__ + "img/bj.59e21b60.png";